import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import type { DashboardOutcomeTile } from '../api/employerVerificationDashboardApi';

export function outcomeTileSx(
  theme: Theme,
  presentation: DashboardOutcomeTile['presentation'],
  selected: boolean,
) {
  const isLight = theme.palette.mode === 'light';
  const base = {
    height: '100%',
    borderRadius: 2,
    cursor: 'pointer' as const,
    transition: 'transform 160ms ease, box-shadow 200ms ease, border-color 200ms ease',
    border: '1px solid',
    backgroundImage: isLight
      ? 'linear-gradient(165deg, #ffffff 0%, #f8fafc 55%, #f1f5f9 100%)'
      : 'linear-gradient(165deg, #1e293b 0%, #0f172a 48%, #0b1220 100%)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: isLight
        ? '0 14px 40px rgba(15, 23, 42, 0.12)'
        : '0 14px 40px rgba(0, 0, 0, 0.45)',
    },
  };

  const accents: Record<
    DashboardOutcomeTile['presentation'],
    { border: string; glow: string; number: string }
  > = {
    success: {
      border: alpha('#2dd4bf', selected ? 0.85 : 0.45),
      glow: alpha('#14b8a6', isLight ? 0.18 : 0.28),
      number: isLight ? '#0d9488' : '#5eead4',
    },
    error: {
      border: alpha('#fb7185', selected ? 0.9 : 0.5),
      glow: alpha('#f43f5e', isLight ? 0.16 : 0.22),
      number: isLight ? '#e11d48' : '#fda4af',
    },
    warning: {
      border: alpha('#fbbf24', selected ? 0.95 : 0.55),
      glow: alpha('#f59e0b', isLight ? 0.2 : 0.25),
      number: isLight ? '#d97706' : '#fcd34d',
    },
    neutral: {
      border: alpha('#a78bfa', selected ? 0.85 : 0.42),
      glow: alpha('#8b5cf6', isLight ? 0.14 : 0.22),
      number: isLight ? '#6366f1' : '#c4b5fd',
    },
  };

  const a = accents[presentation];

  return {
    ...base,
    borderColor: a.border,
    boxShadow: selected
      ? `0 10px 36px ${a.glow}, 0 0 0 1px ${alpha(a.border, 0.35)}`
      : `0 4px 22px ${alpha(a.glow, 0.6)}`,
    ['& .ev-tile-count']: {
      color: a.number,
    },
  };
}
